import React from 'react';
import { Typography } from 'design_system/src';

import { ReactComponent as Success } from 'design_system/src/static/icons/tick-circle.svg';
import { ReactComponent as Info } from 'design_system/src/static/icons/info.svg';
import { ReactComponent as Close } from 'design_system/src/static/icons/close-circle.svg';

// eslint-disable-next-line no-shadow
export enum validationItemState {
	valid = 'valid',
	warning = 'warning',
	invalid = 'invalid',
}

const validationItemStateValues = {
	[validationItemState.valid]: {
		color: 'green_300',
		icon: Success,
	},
	[validationItemState.warning]: {
		color: 'yellow_100',
		icon: Info,
	},
	[validationItemState.invalid]: {
		color: 'red_300',
		icon: Close,
	},
};

export const validationItem = (
	state: validationItemState,
	stateLabel: {
		[validationItemState.valid]?: string;
		[validationItemState.warning]?: string;
		[validationItemState.invalid]?: string;
	},
	small = false,
) => {
	const Icon = validationItemStateValues[state].icon;
	return (
		<>
			<Icon
				className={`${small ? 'dim_md' : 'dim_lg'} text_${
					validationItemStateValues[state].color
				} flex_shrink_0`}
			/>
			<Typography
				scale={small ? 'xxsmall' : 'medium'}
				weight="400"
				textColor={validationItemStateValues[state].color as any}
				className=""
			>
				{stateLabel[state]}
			</Typography>
		</>
	);
};

export const informativeMessage = (
	title: string,
	subtitle: string,
	textColor: any,
	color: string,
) => (
	<div className={`p_xs bg_${color} flex_center_col flex_gap_xs m_b_xs`}>
		<div className="flex_center flex_gap_xs ">
			<Info className={`dim_lg text_${textColor}`} />
			<Typography scale="small" weight="600" textColor={textColor}>
				{title}
			</Typography>
		</div>
		<Typography
			scale="xsmall"
			textColor={textColor}
			weight="400"
			className="text_center"
		>
			{subtitle}
		</Typography>
	</div>
);
